import { createContext } from 'react';

export const AppGlobalStateContext = createContext(null);
